// extracted by mini-css-extract-plugin
module.exports = {"icon":"multipin_icon__29BFC","btn":"multipin_btn__1jt6W","trash":"multipin_trash__1_QL7"};